import udemy from "../assets/png/myntra.png";
import udemy3 from "../assets/png/udemy3.png";

export const blogData = [
  {
    id: 1,
    title: "Myntra Clone",
    description:
      "A visual replica of the original Myntra.com implemented using CSS aimed to replicate the behavior and core theme of Myntra",
    date: "March, 2021",
    image: udemy,
    url: "https://medium.com/@keerramkrishna425/cloning-ecommerce-website-myntra-4516c4cd625d",
  },
  {
    id: 2,
    title: "Udemy Clone",
    description:
      "Dynamic search results fetched from the server to create a complete mimic of user experience along with backend integration",
    date: "March, 2021",
    image: udemy3,
    url: "https://medium.com/@keerramkrishna425/cloning-of-udemy-learning-website-d2d93a907032",
  },
];
